import { lazy } from "react";
import { RouteProps } from "react-router-dom";
import Login from "../pages/presentation/auth/Login";

const ADMIN = {
  GROUP_MGMT: lazy(() => import("../iot/admin/GroupMgmt")),
  USER_MGMT: lazy(() => import("../iot/admin/UserMgmt")),
};
const AUTH = {
  PAGE_404: lazy(() => import("../pages/presentation/auth/Page404")),
};
const IOT = {
  DASHBOARD: lazy(() => import("../iot/dashboard/DashboardPage")),
  UPDATE_SUB_INFO: lazy(() => import("../iot/dashboard/DashboardPage")),
  SUB_REGISTRATION: lazy(() => import("../iot/dashboard/DashboardPage")),
  SIM_MGMT: lazy(() => import("../iot/sim/SimMgmt")),
  SUB_INFO: lazy(() => import("../iot/sim/SubInfo")),
  SUB_REG: lazy(() => import("../iot/sim/SubReg")),
  TOPUP_SUCCESS: lazy(() => import("../iot/sim/TopupResult")),
  IMPORT_INFO: lazy(() => import("../iot/sim/ImportInfo")),
  BALANCE_INFO:lazy(()=>import('../iot/sim/BalanceInfo')),
  CHANGE_SIM:lazy(()=>import('../iot/sim/ChangeSim')),
  CONNECT:lazy(()=>import('../iot/connect/index')),
  TOPUP:lazy(()=>import('../iot/topup/index')),
  SIM_LIST:lazy(()=>import('../iot/sim/SimList')),
};
const PROFILE = {
  INDEX: lazy(() => import("../pages/presentation/profile")),
  FORGOTPASSWORD: lazy(
    () => import("../pages/presentation/profile/ForgotPassword")
  ),
};
const REPORT = {
  ACTIVITE: lazy(() => import("../pages/presentation/report/Activite")),
  REGISTERACTIVITE: lazy(
    () => import("../pages/presentation/report/RegisterActivite")
  ),
  NAPTHE: lazy(() => import("../pages/presentation/report/NapThe")),
};
const DASHBOARD =lazy(()=>import('../pages/presentation/dashboard/DashboardPage'))
const admin: RouteProps[] = [
  /**
   * Landing
   */
  {
    path: "/group-mgmt",
    id: "Quản lý nhóm người dùng",
    element: <ADMIN.GROUP_MGMT />,
  },
  {
    path: "/user-mgmt",
    id: "Quản lý người dùng",
    element: <ADMIN.USER_MGMT />,
  },
  {
    path: "auth-pages/404",
    element: <AUTH.PAGE_404 />,
  },
  {
    path: "auth-pages/login",
    element: <Login />,
  },
];
const iot: RouteProps[] = [
  /**
   * Landing
   */
  {
    path: "/common-dashboard",
    id: "IoT Dashboard",
    element: <IOT.DASHBOARD />,
  },
  {
    path: "/",
    id: "IoT Dashboard",
    element:<DASHBOARD/> ,
  },
  {
    path: "/sim-mgmt",
    id: "Danh sách thuê bao",
    element: <IOT.SIM_MGMT />,
  },
  {
    path: "/connect",
    id: "Đấu nối sim",
    element: <IOT.CONNECT />,
  },
  {
    path: "/topup",
    id: "Nạp thẻ",
    element: <IOT.TOPUP />,
  },
  {
    path: "/sim-list",
    id: "Quản lý sim",
    element: <IOT.SIM_LIST />,
  },
  // {
  //   path: "/sim-mgmt/:_package",
  //   id: "Quản lý SIM",
  //   element: <IOT.SIM_MGMT />,
  // },
  {
    path: "/update-sub-info",
    element: <IOT.UPDATE_SUB_INFO />,
  },
  {
    path: "/subs-registration",
    id: "Đăng ký thông tin",
    element: <IOT.SUB_REGISTRATION />,
  },
  {
    path: "/sub-info",
    id: "Thông tin thuê bao",
    element: <IOT.SUB_INFO />,
  },
  // {
  //   path: "/sub-info/:phoneId",
  //   id: "Thông tin thuê bao",
  //   element: <IOT.SUB_INFO />,
  // },
  {
    path: "/sub-register",
    id: "Đăng ký thông tin",
    element: <IOT.SUB_REG />,
  },
  {
    path: "/topup/hoan-thanh",
    id: "Kết quả nạp thẻ",
    element: <IOT.TOPUP_SUCCESS />,
  },
  {
    path: "/import-info",
    id: "Import thông tin",
    element: <IOT.IMPORT_INFO />,
  },
  {
    path: "/import-info",
    id: "Import thông tin",
    element: <IOT.IMPORT_INFO />,
  },
  {
    path: "/balance-info",
    id: "Mã QR",
    element: <IOT.BALANCE_INFO />,
  },
  // {
  //   path: "/change-sim/:phoneParam",
  //   id: "Đổi sim",
  //   element: <IOT.CHANGE_SIM />,
  // },
  {
    path: "/change-sim",
    id: "Đổi sim",
    element: <IOT.CHANGE_SIM />,
  },
];

const profile: RouteProps[] = [
  {
    path: "/profile",
    id: "Thông tin người dùng",
    element: <PROFILE.INDEX />,
  },
  {
    path: "/forgot-password",
    id: "Đổi mật khẩu",
    element: <PROFILE.FORGOTPASSWORD />,
  },
];
const report: RouteProps[] = [
  {
    path: "/report-active",
    id: "Báo cáo đăng ký gói",
    element: <REPORT.ACTIVITE />,
  },
  {
    path: "/dkkh",
    id: "Báo cáo đăng ký kích hoạt ",
    element: <REPORT.REGISTERACTIVITE />,
  },
  {
    path: "/nap-the",
    id: "Báo cáo nạp thẻ",
    element: <REPORT.NAPTHE />,
  },
];
const contents = [...iot, ...admin, ...profile, ...report];

export default contents;
